var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2909 55.8277L26.8175 54.5185H26.7533C26.3414 55.0755 25.9161 55.4631 25.4774 55.6813C25.0441 55.8938 24.4771 56 23.7763 56C22.9151 56 22.2357 55.7359 21.7382 55.2076C21.2461 54.6793 21 53.9271 21 52.9509C21 51.9288 21.3317 51.1766 21.995 50.6942C22.6637 50.2061 23.6693 49.9363 25.012 49.8846L26.5687 49.8329V49.4109C26.5687 48.4347 26.1033 47.9466 25.1725 47.9466C24.4557 47.9466 23.6132 48.1792 22.6449 48.6443L21.8345 46.8699C22.8669 46.29 24.0117 46 25.2688 46C26.4724 46 27.3952 46.2814 28.0371 46.8441C28.679 47.4068 29 48.2624 29 49.4109V55.8277H27.2909ZM26.5687 51.3661L25.6219 51.4005C24.9104 51.4235 24.3808 51.5613 24.0331 51.814C23.6854 52.0666 23.5115 52.4513 23.5115 52.9681C23.5115 53.7089 23.9074 54.0792 24.6991 54.0792C25.2661 54.0792 25.7182 53.9041 26.0552 53.5538C26.3975 53.2036 26.5687 52.7384 26.5687 52.1585V51.3661Z",
    fill: "#008746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 64C69.0125 64 76 57.3587 76 50C76 48.5656 75.7345 47.1585 75.2366 45.8226L72.6 47.8C72.1582 48.1314 71.5314 48.0418 71.2 47.6C70.8686 47.1582 70.9582 46.5314 71.4 46.2L74.3726 43.9705C73.9661 43.2514 73.4888 42.5623 72.9469 41.9115L67.5882 45.8087C67.1415 46.1336 66.5161 46.0348 66.1913 45.5882C65.8664 45.1415 65.9652 44.5161 66.4118 44.1913L71.5531 40.4522C68.6042 37.7515 64.3851 36 59.5 36C49.9875 36 43 42.6413 43 50C43 57.3587 49.9875 64 59.5 64ZM59.5 67C70.2696 67 79 59.3888 79 50C79 40.6112 70.2696 33 59.5 33C48.7304 33 40 40.6112 40 50C40 59.3888 48.7304 67 59.5 67Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 75L39.7735 65L28.2265 65L34 75ZM34 25L28.2265 35L39.7735 35L34 25ZM35 66L35 34L33 34L33 66L35 66Z",
    fill: "#008746"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 34H48",
    stroke: "#008746",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 66H48",
    stroke: "#008746",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircular);
export default __webpack_public_path__ + "static/media/circular.67c69f02ac60885a9b00c43b9fff6316.svg";
export { ForwardRef as ReactComponent };